export function tokensMapping(symbol: string) {
  const mapping = {
    DAI: { name: 'DAI', address: '0x6b175474e89094c44da98b954eedeac495271d0f' },
    USDC: {
      name: 'USDC',
      address: '0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48'
    },
    USDS: {
      name: 'USDS',
      address: '0xdc035d45d973e3ec169d2276ddab16f1e407384f'
    },
    sUSDS: {
      name: 'sUSDS',
      address: '0xa3931d71877c0e7a3148cb7eb4463524fec27fbd'
    },
    MKR: { name: 'MKR', address: '0x9f8f72aa9304c8b593d555f12ef6589cc3a579a2' },
    SKY: { name: 'SKY', address: '0x56072c95faa701256059aa122697b133aded9279' },
    CHRON: {
      name: 'CHRON',
      address: '0x00000000000000000000000000000000000chron'
    },
    sDAI: {
      name: 'sDAI',
      address: '0x83f20f44975d03b1b09e64809b757c47f942beea'
    },
    SPK: { name: 'SPK', address: '0xc20059e0317de91738d13af027dfc4a50781b066' },
    GROVE: {
      name: 'GROVE',
      address: '0xb30fe1cf884b48a22a50d22a9282004f2c5e9406'
    },
    LMKR: {
      name: 'LMKR',
      address: '0xb4e0e45e142101dc3ed768bac219fc35edbed295'
    },
    lsMKR: {
      name: 'LMKR',
      address: '0xb4e0e45e142101dc3ed768bac219fc35edbed295'
    },
    lsSKY: {
      name: 'lsSKY',
      address: '0x56072c95faa701256059aa122697b133aded9279'
    },
    stUSDS: {
      name: 'stUSDS',
      address: '0x99cd4ec3f88a45940936f469e4bb72a2a701eeb9'
    }
  };

  return mapping[symbol];
}

export function tokensMappingBase(symbol: string) {
  const mapping = {
    USDC: {
      name: 'USDC',
      address: '0x833589fcd6edb6e08f4c7c32d4f71b54bda02913',
      network: 'base'
    },
    USDS: {
      name: 'USDS',
      address: '0x820c137fa70c8691f0e44dc420a5e53c168921dc',
      network: 'base'
    },
    sUSDS: {
      name: 'sUSDS',
      address: '0x5875eee11cf8398102fdad704c9e96607675467a',
      network: 'base'
    },
    SKY: { name: 'SKY', address: '0x60e3c701e65dee30c23c9fb78c3866479cc0944a' }
  };

  return mapping[symbol];
}

export function tokensMappingArbitrum(symbol: string) {
  const mapping = {
    USDC: {
      name: 'USDC',
      address: '0xaf88d065e77c8cc2239327c5edb3a432268e5831',
      network: 'arbitrum'
    },
    USDS: {
      name: 'USDS',
      address: '0x6491c05a82219b8d1479057361ff1654749b876b',
      network: 'arbitrum'
    },
    sUSDS: {
      name: 'sUSDS',
      address: '0xddb46999f8891663a8f2828d25298f70416d7610',
      network: 'arbitrum'
    },
    SKY: { name: 'SKY', address: '' }
  };
  return mapping[symbol];
}
